import React from 'react';
// import ReactDOM from 'react-dom/client';
import ReactDOM from "react-dom";
import '@/styles/index.less';
import App from './App';
import "./public-path";

function render(props: { container?: any; }) {
  // console.log("[react16] react app render");
  const { container } = props;

  // note!!! if we use react 18 render method. ReactDom.createRoot, then the sub App would be empty in main app, also there isn't any error in qikuan. 
  ReactDOM.render(<React.StrictMode><App /></React.StrictMode>, container ? container.querySelector('#root') : document.querySelector('#root'));
}

if (!(window as any).__POWERED_BY_QIANKUN__) {
  // console.log("[react16] react app error");
  render({});
}

export async function bootstrap() {
  // console.log("[react16] react app bootstraped");
}

export async function mount(props: { container?: any; }) {
  // console.log("[react16] props from main framework", props);
  render(props);
}

export async function unmount(props: { container: any; }) {
  // console.log("[react16] react app unmount");
  const { container } = props;
  ReactDOM.unmountComponentAtNode(container ? container.querySelector('#root') : document.querySelector('#root'));
}

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
